// extracted by mini-css-extract-plugin
export default {"container":"hH-z","vocBtn":"iH-z","disabled":"jH-z"};